export const FEATURE_HEADERS = {
  ACRS_FILTERS: 'enable-acrs-filters',
  PERSISTENT_CART: 'enable-persistent-cart',
  CRS_INVENTORY_NAME: 'crs-inventory-name',
  ENABLE_NEW_LEGAL_CONSENT: 'enable-new-legal-consent',
};
